import Logo from "../../assets/logo.png";
import { Typography, Box, styled } from "@mui/material";

const Wrapper = styled(Box)({
  flex: "1 1 50%", 
  minWidth: "150px", 
  marginRight: "5vw", 
  textAlign: "left",
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
});

const StoryTypography = styled(Typography)({
  fontFamily: '"Geist", sans-serif',
  fontWeight: 300,
  color: "rgba(0, 0, 0, 0.7)",
  lineHeight: 1.6,
  width: '40vw',
  fontSize: "clamp(0.4rem, 1vw, 0.8rem)",
});

const LogoImg = styled("img")({
  width: "clamp(40px, 15%, 200px)",
  height: "auto",
  maxHeight: "200px",
  padding: "1vh",
  opacity: 0.7,
});

const StoryText = () => {
  return (
    <Wrapper>
      <StoryTypography variant="body1">
        We believe every wall tells a story. Our curated collection of
        high-quality wall photos is crafted to add warmth, character, and beauty
        to your living spaces. Whether you're decorating your living room or
        creating a calming bedroom atmosphere, our designs are made to inspire.
      </StoryTypography>
      <LogoImg src={Logo} />
    </Wrapper>
  );
};

export default StoryText;
